import React from 'react';
import PropTypes from 'prop-types';

import { Select, Tag } from 'antd';

import geocode from '../../api/geocode';

const Option = Select.Option;

export default class Geocoder extends React.Component{
    constructor(props){
        super(props);
        this.timeout = null;
        this.state = {
            data: [],
        }
    }
    onSearchChange(searchTerm){
        let self = this;

        if (this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }

        function callGeocode(){
            geocode(searchTerm).then((results) => {
                self.setState({
                    data: results,
                });
            });
        }

        this.timeout = setTimeout(callGeocode, 300);
    }
    onChange(value){
        const selectedGeo = this.state.data.filter((result) => result.placeId === value);

        if (selectedGeo.length > 0) {
            this.props.onResultSelect(selectedGeo[0]);
            this.setState({
                value: null,
                data: [],
            });
        }
    }

    render(){
        const {value} = this.state;

        const options = this.state.data.map((d) => (
            <Option key={d.placeId}>{d.formattedAddress} - {d.types.map((type, j) => <Tag key={j}>{type}</Tag> )}</Option>
        ));

        return (
            <div>
                <Select
                    showSearch
                    defaultActiveFirstOption={true}
                    notFoundContent={null}
                    placeholder="Search for Addresses"
                    filterOption={false}
                    value={value}
                    style={{ width: '100%', marginBottom: 10}}
                    onSearch={this.onSearchChange.bind(this)}
                    onChange={this.onChange.bind(this)}
                >
                    {options}
                </Select>
            </div>
        )
    }
}

Geocoder.propTypes = {
    onResultSelect: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/shared/components/Geocoder.js